<script lang="typescript">
    import Subtitle2 from "shared/typography/subtitle2.svelte";

    export let title = "Subtitle";
    export let color = "var(--color-level-7)";
    export let icon;
</script>

<section class="section-subheader">
    <svelte:component this={icon} width={32} heigth={32} {color} />
    <div class="content">
        <Subtitle2 text={title} {color} />
    </div>
</section>

<style>
    .section-subheader {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .content {
        display: flex;
        flex-direction: column;
        margin-left: 8px;
    }
</style>
